import { useCallback, useEffect } from "react"
import { subscriptionService } from "../../../data/services/subscriptionService"
import { useApiStatus } from "../../../common/hooks/useApiStatus"

export const useGenerateAdminCheckoutSession = ({
    isLoading,
    apiRequest,
    email,
    sale,
    setCheckoutSession,
}) => {
    // `sale` : le jeton de la vente porté par le lien — c'est lui qui fait
    // proposer la carte enregistrée ; sans lui, la page demande une carte.
    const generateCheckoutSession = useCallback(() => {
        apiRequest(
            subscriptionService.adminCreateSubscription,
            {},
            { email, ...(sale ? { sale } : {}) }
        )
    }, [email, sale])
    useApiStatus(
        subscriptionService.adminCreateSubscription,
        null,
        true,
        (data) => setCheckoutSession(data)
    )

    useEffect(() => {
        if (isLoading) return

        generateCheckoutSession()
    }, [generateCheckoutSession, isLoading])
}
